export const INITIAL_FORM_FEATURE = {
  title: '',
  description: null,
  image: null,
  attachmentId: null,
  localizations: [
    {
      title: '',
      product_feature_id: '',
      description: null,
      languageCode: 'RU',
    },
    {
      title: '',
      product_feature_id: '',
      description: null,
      languageCode: 'EN',
    },
  ],
}
